import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { ensureEstatesQueryData } from '@/features/estates/api/estates';
import { SORT_BY_DIRECTION, SORT_BY_VALUES } from '@/utils/sortTypes';

export const Route = createFileRoute('/_authenticated/_sidebar-layout/estates/')({
  validateSearch: zodValidator(
    z.object({
      view: fallback(z.enum(['grid', 'list', 'map']).optional(), 'list'),
      search: fallback(z.string().optional(), ''),
      enableFilters: fallback(z.boolean().optional(), false),
      filterOwn: fallback(z.boolean().optional(), false),
      filters: z.record(z.unknown()).optional(),
      sort: fallback(
        z
          .object({
            by: z.enum(SORT_BY_VALUES),
            order: z.enum(SORT_BY_DIRECTION),
          })
          .optional(),
        undefined
      ),
    })
  ),
  loader: ensureEstatesQueryData,
});
